/* PRS header: mega menu open/close (hover-intent + click/keyboard) and sidebar tab switching. Desktop only. */
(function () {
  var OPEN_DELAY = 80;
  var CLOSE_DELAY = 200;
  var TAB_DELAY = 60;
  var desktop = window.matchMedia('(min-width: 1200px)');
  var openItem = null;
  var lastPointer = 'mouse';

  function link(item) {
    return item.querySelector('.prs-header__menu-link');
  }

  function open(item) {
    if (!desktop.matches || openItem === item) return;
    if (openItem) close(openItem);
    item.classList.add('is-open');
    link(item).setAttribute('aria-expanded', 'true');
    openItem = item;
  }

  function close(item) {
    if (!item) return;
    item.classList.remove('is-open');
    link(item).setAttribute('aria-expanded', 'false');
    if (openItem === item) openItem = null;
  }

  function activateTab(item, index) {
    var tabs = item.querySelectorAll('[data-prs-tab]');
    var panes = item.querySelectorAll('[data-prs-pane]');
    Array.prototype.forEach.call(tabs, function (tab) {
      var on = tab.getAttribute('data-prs-tab') === String(index);
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(panes, function (pane) {
      pane.classList.toggle('is-active', pane.getAttribute('data-prs-pane') === String(index));
    });
  }

  /* ---------- Mobile menu (<1200px) ---------- */
  function header() {
    return document.querySelector('.prs-header');
  }

  function burger() {
    return document.querySelector('.prs-header [data-prs-burger]');
  }

  function setPanelTop() {
    var h = header();
    var panel = h && h.querySelector('.prs-header__panel');
    if (!h || !panel) return;
    // The theme's sticky can engage a moment after scrolling, so never place the panel above the
    // bottom of a stuck header (its own height).
    var top = Math.max(h.offsetHeight, Math.round(h.getBoundingClientRect().bottom));
    panel.style.setProperty('--prs-panel-top', top + 'px');
  }

  function undrill() {
    var h = header();
    if (!h) return;
    var nav = h.querySelector('.prs-header__nav');
    if (nav) nav.classList.remove('is-drilled');
    Array.prototype.forEach.call(h.querySelectorAll('.prs-header__menu-item.is-drilled'), function (li) {
      li.classList.remove('is-drilled');
    });
  }

  function drill(item) {
    var nav = item.closest('.prs-header__nav');
    if (!nav) return;
    nav.classList.add('is-drilled');
    item.classList.add('is-drilled');
    nav.scrollTop = 0;
  }

  function openMobile() {
    var h = header();
    if (!h) return;
    // Without sticky the header scrolls away, so bring it back into view before opening
    if (!h.hasAttribute('data-sticky-mb') && h.getBoundingClientRect().top < 0) window.scrollTo(0, 0);
    setPanelTop();
    h.classList.add('is-mobile-open');
    document.documentElement.classList.add('prs-menu-open');
    if (burger()) burger().setAttribute('aria-expanded', 'true');
  }

  function closeMobile() {
    var h = header();
    if (!h) return;
    h.classList.remove('is-mobile-open');
    document.documentElement.classList.remove('prs-menu-open');
    if (burger()) burger().setAttribute('aria-expanded', 'false');
    undrill();
  }

  function isMobileOpen() {
    var h = header();
    return !!h && h.classList.contains('is-mobile-open');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var burgerBtn = t.closest('[data-prs-burger]');
    if (burgerBtn) {
      e.preventDefault();
      if (isMobileOpen()) closeMobile(); else openMobile();
      return;
    }

    if (t.closest('[data-prs-back]')) {
      e.preventDefault();
      undrill();
      return;
    }

    var acc = t.closest('[data-prs-acc]');
    if (acc) {
      e.preventDefault();
      var group = acc.closest('.prs-mega__group');
      if (!group) return;
      var willOpen = !group.classList.contains('is-expanded');
      Array.prototype.forEach.call(group.parentNode.querySelectorAll('.prs-mega__group.is-expanded'), function (g) {
        g.classList.remove('is-expanded');
        var b = g.querySelector('[data-prs-acc]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) {
        group.classList.add('is-expanded');
        acc.setAttribute('aria-expanded', 'true');
      }
    }
  });

  // Opening the theme's mobile search should not leave the menu panel underneath it
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('.prs-header [data-search-mobile-toggle]') && isMobileOpen()) {
      closeMobile();
    }
  }, true);

  function bind(item) {
    if (item.getAttribute('data-prs-bound')) return;
    item.setAttribute('data-prs-bound', 'true');

    var openTimer;
    var closeTimer;
    var tabTimer;

    function scheduleOpen() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
      openTimer = setTimeout(function () { open(item); }, openItem ? 0 : OPEN_DELAY);
    }

    function scheduleClose() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { close(item); }, CLOSE_DELAY);
    }

    item.addEventListener('mouseenter', function () {
      if (lastPointer === 'touch') return;
      scheduleOpen();
    });
    item.addEventListener('mouseleave', function () {
      if (lastPointer === 'touch') return;
      scheduleClose();
    });

    // Sidebar tabs: switch on hover (with a small delay) or click
    Array.prototype.forEach.call(item.querySelectorAll('[data-prs-tab]'), function (tab) {
      var index = tab.getAttribute('data-prs-tab');
      tab.addEventListener('mouseenter', function () {
        clearTimeout(tabTimer);
        tabTimer = setTimeout(function () { activateTab(item, index); }, TAB_DELAY);
      });
      tab.addEventListener('mouseleave', function () { clearTimeout(tabTimer); });
      tab.addEventListener('click', function () { activateTab(item, index); });
      tab.addEventListener('focus', function () { activateTab(item, index); });
    });

    var trigger = link(item);

    // Hovering already opened the menu, so a mouse click follows the link. Touch and keyboard
    // activation open the menu first and only follow the link on a second activation.
    trigger.addEventListener('click', function (e) {
      if (!desktop.matches) {
        e.preventDefault();
        drill(item);
        return;
      }
      var viaMouse = lastPointer === 'mouse' && e.detail > 0;
      if (viaMouse && item.classList.contains('is-open')) return;
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        clearTimeout(closeTimer);
        open(item);
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        open(item);
        var first = item.querySelector('.prs-mega__tab.is-active, .prs-mega__pane.is-active a');
        if (first) first.focus();
      }
    });

    item.addEventListener('focusout', function (e) {
      if (!item.contains(e.relatedTarget)) scheduleClose();
    });
    item.addEventListener('focusin', function () { clearTimeout(closeTimer); });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.prs-header [data-prs-mega]'), bind);
  }

  document.addEventListener('pointerdown', function (e) {
    lastPointer = e.pointerType === 'touch' || e.pointerType === 'pen' ? 'touch' : 'mouse';
    if (openItem && !openItem.contains(e.target)) close(openItem);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isMobileOpen()) {
      closeMobile();
      if (burger()) burger().focus();
      return;
    }
    if (e.key === 'Escape' && openItem) {
      var item = openItem;
      close(item);
      link(item).focus();
    }
  });
  document.addEventListener('mousemove', function () { lastPointer = 'mouse'; }, { passive: true });

  function onBreakpoint() {
    if (!desktop.matches && openItem) close(openItem);
    if (desktop.matches && isMobileOpen()) closeMobile();
  }

  desktop.addEventListener
    ? desktop.addEventListener('change', onBreakpoint)
    : desktop.addListener(onBreakpoint);

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var item = el && el.closest ? el.closest('[data-prs-mega]') : null;
    if (!item) return;
    open(item);
    var pane = el.closest ? el.closest('[data-prs-pane]') : null;
    var tab = el.hasAttribute && el.hasAttribute('data-prs-tab') ? el : null;
    var index = tab ? tab.getAttribute('data-prs-tab') : pane ? pane.getAttribute('data-prs-pane') : null;
    if (index !== null) activateTab(item, index);
  });
  document.addEventListener('shopify:block:deselect', function () { if (openItem) close(openItem); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
